import styled from '@emotion/styled'

const StatusPillContainer = styled.div`
	background: #e7eaf4;
	width: 8rem;
	border-radius: 22.5px;
	padding: 0.25rem 0.5rem;
	font-size: 0.75rem;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #000000;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export { StatusPillContainer }
